import { getInvestorSessionToken, setInvestorSessionToken } from '../api/investorSession'

function withBase(path: string) {
  const base = import.meta.env.BASE_URL || '/'
  return `${base}${path}`.replace(/\/{2,}/g, '/')
}

export const INVESTOR_LOGIN_HREF = withBase('investorkiosk/investorLogin.html')
export const INVESTOR_VERIFY_HREF = withBase('investorkiosk/InvestorVerify.html')

export function captureInvestorSessionFromUrl(): string {
  const params = new URLSearchParams(window.location.search)
  const fromQuery = params.get('sessionToken')?.trim() ?? ''
  if (fromQuery) {
    setInvestorSessionToken(fromQuery)
    params.delete('sessionToken')
    const query = params.toString()
    window.history.replaceState(
      {},
      '',
      `${window.location.pathname}${query ? `?${query}` : ''}${window.location.hash}`,
    )
  }
  return fromQuery || getInvestorSessionToken()
}

export function goToInvestorVerify(sessionToken?: string | null): void {
  if (sessionToken) {
    setInvestorSessionToken(sessionToken)
  }
  const token = sessionToken || getInvestorSessionToken()
  const url = new URL(INVESTOR_VERIFY_HREF, window.location.origin)
  if (token) {
    url.searchParams.set('sessionToken', token)
  }
  const target = window.top ?? window
  target.location.replace(url.href)
}

export function goToInvestorLogin(): void {
  setInvestorSessionToken(null)
  const target = window.top ?? window
  target.location.replace(new URL(INVESTOR_LOGIN_HREF, window.location.origin).href)
}
